import { render } from "./TimeSelectorComponent.vue?vue&type=template&id=63d7d5a6&scoped=true&ts=true"
import script from "./TimeSelectorComponent.ts?vue&type=script&lang=ts"
export * from "./TimeSelectorComponent.ts?vue&type=script&lang=ts"

import "./TimeSelectorComponent.scss?vue&type=style&index=0&id=63d7d5a6&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d7d5a6"]])

export default __exports__